import { useBreakpointValue } from '@chakra-ui/react'

export const useResponsiveValue = <V extends string | boolean>(value: V | V[] | Record<string, V>): V | undefined => {
  const breakpointValueHookArg = typeof value === 'object' ? value : []
  const breakPointValue = useBreakpointValue(breakpointValueHookArg)

  return breakPointValue ?? (value as V)
}
